import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { style: {"margin-bottom":"0.4rem"} }
const _hoisted_5 = {
  key: 0,
  class: "word"
}
const _hoisted_6 = { style: {"color":"#ff5323","margin-right":"0.5rem"} }
const _hoisted_7 = { class: "phonetic" }
const _hoisted_8 = { class: "header-description" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content-center" }
const _hoisted_11 = { class: "content-center-box" }

import { IonPage, modalController } from "@ionic/vue";
import { computed, onMounted, ref } from "vue";
import { useToggle } from "@vueuse/core";
import wordShow from "./wordShow.vue";
import AudioComp from "@/views/AIGenerate/components/AudioComp.vue";

interface RootJsonType {
  wordRoot: string;
  rootchinesedefinition: string;
  rootchineseDefinition: string;
  rootphonetic: string;
  words: WordJsonType[];
}
interface WordJsonType {
  index: string;
  word: string;
  chinesedefinition: string;
  chineseDefinition: string;
  phonetic: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RootsAndAffixes',
  props: {
    name: { default: "" },
    resJson: { default: () => ({
      wordRoot: "",
      rootchineseDefinition: "",
      rootphonetic: "",
      words: [],
    }) }
  },
  setup(__props: any) {

const props = __props;

const [isAnimating, changeIsAnimating] = useToggle();
const currentList = ref<WordJsonType[]>();
const currentIndex = ref(0);
function close() {
  modalController.dismiss();
}

const resJson = computed(() => props.resJson);
const maxIndexLength = computed(() => Math.ceil(resJson.value.words.length / 4));
onMounted(() => {
  getCurrentList(currentIndex.value);
});

function getCurrentList(index: number) {
  currentIndex.value = index;
  const list = resJson.value.words;
  currentList.value = list.slice(index * 4, index * 4 + 4);
}
function changeStep(type: "next" | "back") {
  if (
    (type === "back" && currentIndex.value <= 0) ||
    (type === "next" && currentIndex.value >= maxIndexLength.value - 1) ||
    isAnimating.value
  ) {
    return;
  }
  changeIsAnimating(true);
  setTimeout(() => {
    getCurrentList(type === "next" ? currentIndex.value + 1 : currentIndex.value - 1);
  }, 300);
}
function handlePhonetic(phonetic: string) {
  const regex = /^(?:\/(.*)\/|\[(.*)])$/;
  if (!regex.test(phonetic)) {
    return `[${phonetic}]`;
  }
  return phonetic ? phonetic.replace(/^\/(.+)\/$/g, "[$1]") : "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(props.name), 1),
            (resJson.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(resJson.value.wordRoot), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, "[" + _toDisplayString(resJson.value.rootphonetic) + "]", 1),
                    _createVNode(AudioComp, {
                      word: resJson.value.wordRoot,
                      class: "audio"
                    }, null, 8, ["word"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(resJson.value.rootchinesedefinition ?? resJson.value.rootchineseDefinition), 1)
          ]),
          _createElementVNode("i", {
            class: "iconfont icon-guanbi-xiao header-close",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["content-left", [currentIndex.value <= 0 && 'content-active']]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStep('back')))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "iconfont icon-back" }, null, -1)
          ]), 2),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (resJson.value.wordRoot)
                ? (_openBlock(), _createBlock(wordShow, {
                    key: 0,
                    name: resJson.value.wordRoot,
                    root: resJson.value.wordRoot
                  }, null, 8, ["name", "root"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["content-center-out", [_unref(isAnimating) && 'animation']]),
              onAnimationend: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeIsAnimating)(false)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "content-center-out_item"
                }, [
                  (item['单词'])
                    ? (_openBlock(), _createBlock(wordShow, {
                        key: 0,
                        name: item['单词'],
                        phonetic: handlePhonetic(item['音标']),
                        definition: item['翻译'],
                        root: resJson.value.wordRoot
                      }, null, 8, ["name", "phonetic", "definition", "root"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 34)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["content-right", [currentIndex.value >= maxIndexLength.value - 1 && 'content-active']]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeStep('next')))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "iconfont icon-back" }, null, -1)
          ]), 2)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1))
      ])
    ]),
    _: 1
  }))
}
}

})